import { DatePicker } from '@progress/kendo-react-dateinputs'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import classNames from 'classnames'
import { formatLocalDateUTC } from 'utils/date'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const transactionNotesColumns: GridColumn[] = [
  {
    title: 'Description',
    field: 'description',
    show: true,
    filterable: false,
    className: classNames('table-columns__content', 'table-columns__break-word'),
  },
  {
    title: 'Expiry Date',
    field: 'expiryDate',
    editor: 'date',
    cell: (gridCellProps: GridCellProps): JSX.Element => {
      if (!gridCellProps.dataItem.inEdit) {
        return (
          <td className='table-columns__date'>
            {formatLocalDateUTC(gridCellProps.dataItem.expiryDate, true)}
          </td>
        )
      }
      return (
        <td className='table-columns__date'>
          <DatePicker
            value={
              gridCellProps?.dataItem?.expiryDate
                ? new Date(gridCellProps.dataItem.expiryDate.toString())
                : null
            }
            onChange={(event) => {
              if (gridCellProps?.onChange && event?.target?.value) {
                gridCellProps.onChange({
                  ...event,
                  ...gridCellProps,
                  dataItem: gridCellProps.dataItem,
                  field: 'expiryDate',
                  value: event.target.value,
                })
              }
            }}
          />
        </td>
      )
    },
    show: true,
    width: 120,
    minResizableWidth: 120,
  },
  {
    title: 'Created Date',
    field: 'createdDate',
    cell: (gridCellProps: GridCellProps): JSX.Element => {
      return (
        <td className='transaction-columns__date'>
          {formatLocalDateUTC(gridCellProps.dataItem.createdDate, true)}
        </td>
      )
    },
    show: true,
    filterable: false,
    width: 120,
    minResizableWidth: 120,
  },
  {
    title: 'User',
    field: 'updatedBy.name',
    editable: false,
    show: true,
    width: 180,
  },
]
